import { render, staticRenderFns } from "./TareaManualFormComponent.vue?vue&type=template&id=2b0480a0&"
import script from "./TareaManualFormComponent.vue?vue&type=script&lang=js&"
export * from "./TareaManualFormComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports